export const defaultState = {
  votingGroups: [],
  votingGroupUnits: [],
  votingHighestScores: [],
  votingDepartmentGroupScores: [],
  behaviors: [],
  ratings: [],
  myVotes: [],
};
